import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import Spinner from '../../../spinner/spinner';
import { Table, Button, Modal } from 'antd';
import EditableCell from "./editableCell";
import { getCurrentChurchGroups } from './queries/getCurrentChurchGroups';
import { deleteChurchGroup } from "./mutations/deleteChurchGroup";
import { ROLES } from '../../../authorization/roles';
import './groupsPage.css';

class GroupsPage extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedRowKeys: [], newData: [], loading: false, added: false };
  }

  get dataSource() {
    return(
      this.props.data.church.churchGroups.edges.map(edges => edges.node).map((group) => {
        return {name: group.name, membersCount: group.membersCount, key: group.id};
      }).concat(this.state.newData)
    );
  }

  get rowSelection() {
    return {
      onSelect: (_selectedRowKeys, _selected, selectedRows) => { this.selectRows(selectedRows) },
      onSelectAll: (_selected, selectedRows) => { this.selectRows(selectedRows) },
      getCheckboxProps: (record) => ({
        disabled: record.membersCount !== 0
      })
    };
  }

  get columns() {
    return(
      [{
        title: 'Group',
        dataIndex: 'name',
        className: 'groups-page__groups-column',
        sorter: (firstGroup, secondGroup) => {
          if(firstGroup.name < secondGroup.name) {
            return -1;
          } else if(firstGroup.name > secondGroup.name) {
            return 1;
          } else {
            return 0;
          }
        },
        render: this.renderEditableCell
      }, {
        title: 'Members',
        dataIndex: 'membersCount',
        className: 'groups-page__members-column',
        sorter: (firstGroup, secondGroup) => firstGroup.membersCount - secondGroup.membersCount
      }]
    );
  }

  selectRows(selectedRows) {
    this.setState({ selectedRowKeys: selectedRows.map(rows => rows.key) });
  }

  mutationParams(groupId) {
    return {
      variables: {
        input: {
          id: groupId
        }
      },
      update: (proxy) => {
        const data = proxy.readQuery(
          { query: getCurrentChurchGroups, variables: { churchId: this.props.selectedChurch.id } }
        );
        const index = data.church.churchGroups.edges.findIndex((edge) => { return edge.node.id === groupId });
        if (index > -1) {
          data.church.churchGroups.edges.splice(index, 1);
        }
        proxy.writeQuery({ query: getCurrentChurchGroups, data });
      }
    };
  }

  async submitData(params) {
    try {
      this.setState({ loading: true });
      await this.props.mutate(params);
    } finally {
      this.setState({ loading: false });
    }
  }

  onCreateGroup = (proxy, { data: { createChurchGroup } }) => {
    const data = proxy.readQuery(
      { query: getCurrentChurchGroups, variables: { churchId: this.props.selectedChurch.id } }
    );
    const newNode = { node: createChurchGroup.churchGroup, __typename: "ChurchGroupEdge" };
    data.church.churchGroups.edges.push(newNode);
    this.setState({ newData: [], added: false });
    proxy.writeQuery({ query: getCurrentChurchGroups, data });
  };

  renderEditableCell = (text, record) => {
    return (
      <EditableCell onCreateGroup={this.onCreateGroup}
                    onCancelClick={this.onCancelClick}
                    added={this.state.added}
                    value={text}
                    groupId={record.key}
                    churchId={this.props.selectedChurch.id}
                    membersCount={record.membersCount}/>
    );
  };

  onCancelClick = () => {
    this.setState({ newData: [], added: false });
  };

  onAddClick = () => {
    const newData = { key: -1, name: null, membersCount: 0 };
    this.setState({ newData: [newData], added: true });
  };

  onDeleteClick = () => {
    Modal.confirm({
      title: "Are you sure you want to delete selected groups?",
      okText: "Delete",
      width: 500,
      onOk: () => {
        this.state.selectedRowKeys.forEach((groupId) => this.submitData(this.mutationParams(groupId)));
        this.setState({ selectedRowKeys: [] });
      }
    });
  };

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    } else {
      const hasSelected = this.state.selectedRowKeys.length > 0;
      return(
        <div className="m-24">
          <h2 className="dashboard-section-title">Groups</h2>
          <Table rowSelection={this.rowSelection} className="groups-page__table" columns={this.columns} dataSource={this.dataSource} pagination={false} />
          <div className="groups-page__controls">
            <Button disabled={this.state.added} type="primary" onClick={this.onAddClick}>ADD GROUP</Button>
            <Button type="danger" disabled={!hasSelected} loading={this.state.loading} onClick={this.onDeleteClick} className="profile-form__inactive-button">
              DELETE SELECTED
            </Button>
          </div>
        </div>
      );
    }
  }
}

export default compose(
  graphql(getCurrentChurchGroups, {
    options: ({ selectedChurch }) => ({ variables: { churchId: selectedChurch.id } })
  }),
  graphql(deleteChurchGroup)
)(GroupsPage);



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/groups/groupsPage.js